import React from "react";

const Location = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-location"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-location"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M12,.042a9.992,9.992,0,0,0-9.981,9.98c0,2.57,1.99,6.592,5.915,11.954a5.034,5.034,0,0,0,8.132,0c3.925-5.362,5.915-9.384,5.915-11.954A9.992,9.992,0,0,0,12,.042ZM12,14a4,4,0,1,1,4-4A4,4,0,0,1,12,14Z" />
    </svg>
  );
};

export default Location;
